import { render } from "./goodsList.vue?vue&type=template&id=f0e6f508&scoped=true"
import script from "./goodsList.vue?vue&type=script&lang=js"
export * from "./goodsList.vue?vue&type=script&lang=js"

import "./goodsList.vue?vue&type=style&index=0&id=f0e6f508&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f0e6f508"

export default script